// Corporate programs listing data - separated to avoid babel plugin issues
export const programs = [
  {
    id: 1,
    name: 'Security Awareness Training',
    description: 'Educate your workforce on recognizing and responding to cyber threats with engaging, interactive training modules.',
    duration: '4-8 hours',
    format: 'On-site or Virtual',
    tags: ['Awareness', 'Phishing', 'Social Engineering'],
    level: 'Beginner',
    targetAudience: ['All employees', 'New hires', 'Remote workers', 'Customer-facing staff'],
    featured: true,
    popular: true,
    status: 'active',
  },
  {
    id: 2,
    name: 'HackTheWeb: Pentesting Beyond Basics',
    description: 'Hands-on technical training for IT and security teams covering pentesting techniques aligned to OWASP top 10.',
    duration: '2-4 days',
    format: 'On-site or Virtual',
    tags: ['Technical', 'Hands-on','Offense'],
    level: 'Intermediate',
    targetAudience: ['Professional pen testers', 'Bug hunters', 'Security enthusiasts'],
    featured: true,
    popular: false,
    status: 'active',
  },
  {
    id: 3,
    name: 'HackTheCloud: Attacking AWS & GCP Cloud',
    description: 'Hands-on Technical training focused on understanding how Cloud infrastructures can be pentested',
    duration: '2 Days',
    format: 'On-site or Virtual',
    tags: ['Technical', 'Hands-on', 'Offense'],
    level: 'Intermediate',
    targetAudience: ['Cloud security professionals', 'DevOps engineers', 'Cloud architects'],
    featured: false,
    popular: true,
    status: 'active',
  },
  {
    id: 4,
    name: 'Attacking and Defending Software Supply Chains',
    description: 'A hands-on attacker-to-defender approach to understanding, exploiting, and securing the software supply chain across developer, CI/CD, and deployment environments.',
    duration: '3 Days',
    format: 'On-site',
    tags: ['Offense', 'Defense', 'Supply-Chain'],
    level: 'Intermediate',
    targetAudience: ['DevSecOps engineers', 'Development teams', 'Security architects'],
    featured: false,
    popular: false,
    status: 'active',
  },
  {
    id: 5,
    name: "Offensive AI: Attacking AI Native Apps, IDE's, & Browsers",
    description: "A hands-on course on exploiting and weaponizing vulnerabilities in enterprise AI systems, from prompt injection to agentic and supply-chain attacks.",
    duration: '3 Days',
    format: 'On-site',
    tags: ['Offense', 'Defense', 'Supply-Chain'],
    level: 'Intermediate',
    targetAudience: ['Security professionals', 'AI security researchers', 'AppSec teams'],
    featured: false,
    popular: false,
    status: 'active',
  },
  {
    id: 6,
    name: 'Read. Break. Fix: Secure Code Review in Practice',
    description: 'A hands-on secure code review course that teaches participants to think like attackers, find real-world vulnerabilities, and fix them before they reach production.',
    duration: '3 Days',
    format: 'On-site',
    tags: ['Secure-Code', 'Defense', 'Code-Review'],
    level: 'Intermediate',
    targetAudience: ['Security professionals', 'Software engineers', 'AppSec teams'],
    featured: false,
    popular: false,
    status: 'active',
  },
  {
    id: 7,
    name: 'HuntCraft: Practical Threat Hunting',
    description: 'Hands-on threat hunting training focused on real-world detection and mastery of Sigma, SPL, and KQL.',
    duration: '3 Days',
    format: 'On-site / Virtual',
    tags: ['Threat-Hunting', 'Defense', 'Hands-On'],
    level: 'Intermediate',
    targetAudience: ['SOC analysts', 'Threat hunters', 'Security operations professionals'],
    featured: false,
    popular: false,
    status: 'active',
  },
];
